import React from 'react';
import i18n from '../../../utils/ChrI18n';
import ChrBadge from '../PageUI/Basic/ChrBadge';

const TopBar = props => {
  const {
    backLink,
    imageData,
    title,
    titleClass,
    titleBadge,
    titleBadgeType,
    subTitle,
    containerClass,
    alertBox,
    pageActions
  } = props;

  return(
    <div className={`bg-white ${containerClass}`}>
      <div className='d-flex gap-2'>
        {
          backLink && <a href={ backLink } className='text-default d-flex'>
            <small className='d-flex p-2'>
              <i className="fa-regular fa-arrow-left font-16 fa-fw"/>
              <span className="sr-only ">{ i18n.t("display_string.Back") }</span>
            </small>
          </a>
        }

        { imageData && <>{ imageData }</> }

        <div className="d-flex flex-column gap-4 flex-fill">
          <div className="d-flex flex-column flex-fill">
            <div className="d-flex flex-fill align-items-center gap-2">
              <span className={`break-word ${titleClass}`}>{ title }</span>
              { titleBadge && <ChrBadge type={ titleBadgeType } className='rounded px-3'> { titleBadge }</ChrBadge> }
              { pageActions && pageActions.length > 0 && (
                <div className="ml-auto d-flex gap-2">
                  { pageActions.map((action, index) => (
                    <a key={index} href={ action.url } className="btn btn-primary btn-lg btn-rounded-5">
                      { action.label }
                    </a>
                  ))}
                </div>
              )}
            </div>

            { subTitle && <>{ subTitle }</> }
          </div>

          { alertBox && <>{ alertBox }</> }
        </div>
      </div>
    </div>
  );
};

export default TopBar;